/**
 * RoleDropdownSearch
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown, DropdownProps } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';
import { selectOptions } from './selectors';

interface OwnProps {
    clearPageOnChange: boolean;
    multiple?: boolean;
    fluid?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}
interface ConnectedProps {
    options?: {
        key: number;
        text: string;
        value: number;
    }[];
    roles?: string | string[];
}

export type Props = OwnProps & DispatchProps & ConnectedProps;

export class RoleDropdownSearch extends React.PureComponent<Props> {
    handleChange = (
        event: React.SyntheticEvent<HTMLElement, Event>,
        data: DropdownProps
    ): void => {
        const { clearPageOnChange } = this.props;

        this.props.updateQueryString({
            ...(clearPageOnChange ? { page: undefined } : {}),
            roles: data.value,
            selectedEvent: undefined
        });
    };

    render(): React.ReactElement {
        const { roles, options, multiple } = this.props;

        return (
            <Dropdown
                placeholder="All Roles"
                search
                selection
                value={roles || []}
                clearable
                selectOnBlur={false}
                options={options}
                onChange={this.handleChange}
                lazyLoad
                multiple={multiple}
                closeOnChange
                fluid
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<any, OwnProps, ConnectedProps>(
    {
        roles: makeSelectQueryStringValue('roles'),
        options: selectOptions
    }
);

export default connect(
    mapStateToProps,
    { updateQueryString }
    // @ts-ignore
)(RoleDropdownSearch);
